// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"565":"1b4acb00","3243":"bdcb8ae6","5632":"5c153c23","7948":"1e6d7994"}[chunkId] + ".chunk.css";
};